import type { ReactNode } from 'react';

import { Document, Page } from '@react-pdf/renderer';

import { basePdfStyles } from '../styles';

export function PdfPage({ children }: { children: ReactNode }) {
  const { page } = basePdfStyles;

  return (
    <Document>
      <Page size="A4" orientation="portrait" wrap style={page}>
        {children}
      </Page>
    </Document>
  );
}
